// Clinic portal chat — message the lab. Same panel as staff, scoped to the clinic's own threads.
import { ChatPanel } from '../../ui/ChatPanel.tsx';

export function PortalChat() {
  return (
    <div className="space-y-3">
      <div>
        <h1 className="text-xl font-bold tracking-tight text-ink">Chat with the lab</h1>
        <p className="text-sm text-muted">Ask a question, share a file, or follow up on a case.</p>
      </div>
      <ChatPanel mode="clinic" />
    </div>
  );
}
